import { ICompactProduct } from "api/interfaces/get-page-details/common/CompactProduct.type";
import Text from "component/design-system/typography/Text";
import BottomSheetWrapper from "modules/modals/BottomSheetWrapper";
import { useState } from "react";
import HideIf from "util/HideIf";
import { IProductReview } from "api/interfaces/product-review.type";
import { getThumbmailSrc } from "../../../../../util/product/getThumbmailSrc";
import PAImage from "../../../../design-system/images/PAImage";
import CreateReviewForm from "../CreateReviewForm";
import styles from "./createReview.module.scss";

interface IProps{
  product: ICompactProduct;
  onHide: () => void;
  prefilledReview?: IProductReview;
}

function CreateReviewModal(props: IProps) {
  const {
    product, onHide, prefilledReview,
  } = props;
  const [onSubmit, setOnSubmit] = useState(false);

  return (
    <BottomSheetWrapper
      title={onSubmit ? "Review Submitted - Thank you!" : "Create Review"}
      onHide={onHide}
    >
      <HideIf show={!onSubmit}>
        <div className="nopadding p-b-15">
          <div
            className="d-flex col-sm-2 col-xs-4"
            style={{ minWidth: "80px", paddingRight: "calc(1.5 * var(--safari-root-font, 10px))" }}
          >

            <PAImage
              src={getThumbmailSrc(product)}
              width={80}
              height={80}
              lazyLoad={false}
            />
          </div>

          <div className="col-sm-10 col-xs-8">

            <Text size={4} bold>
              {product.description}
            </Text>

            <Text size={6} bold>
              by
              {" "}
              {product.manufacturer}
            </Text>
          </div>
        </div>
      </HideIf>

      <div className={`col-sm-12 col-xs-12 p-t-10 ${styles.create_review_form} ${onSubmit ? styles.review_form_success : ""}`}>
        <CreateReviewForm product={product} setOnSubmit={setOnSubmit} prefilledReview={prefilledReview} />
      </div>
    </BottomSheetWrapper>
  );
}

export default CreateReviewModal;
